import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import LetterTile from './LetterTile';
import { Content } from '../types';

type Props = {
  onTileClick: (tile: Content) => void;
  selectedTile: Content | null;
  tiles: Content[];
};

const LetterTilesGrid: React.FC<Props> = ({ onTileClick, selectedTile, tiles }) => {
  const [selected, setSelected] = useState<Content | null>(selectedTile);

  const handleTileClick = (tile: Content) => {
    onTileClick(tile);
  };

  useEffect(() => {
    setSelected(() => selectedTile);
  }, [selectedTile]);

  return (
    <Grid alignItems="center" container direction="row" justifyContent="flex-start" spacing={2}>
      {tiles.map((tile: Content) => (
        <Grid key={tile.id} item>
          <LetterTile
            isSelected={selected?.value === tile.value}
            onClick={handleTileClick}
            tile={tile}
          ></LetterTile>
        </Grid>
      ))}
    </Grid>
  );
};

export default LetterTilesGrid;
